import { OnInit } from '@angular/core';
import { DacConfig } from "../../shared/services/dac-config.service";
var AdminComponent = /** @class */ (function () {
    function AdminComponent(dacConfig) {
        this.dacConfig = dacConfig;
    }
    AdminComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(AdminComponent.prototype, "canManageAssessments", {
        get: function () {
            return this.dacConfig.isFeatureEnabled("admin.assessments.navigation");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdminComponent.prototype, "shouldShowAddoHome", {
        get: function () {
            return this.dacConfig.isFeatureEnabled("addo.dashboard.admin");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdminComponent.prototype, "canShop", {
        get: function () {
            return this.dacConfig.isFeatureEnabled("admin.shop");
        },
        enumerable: true,
        configurable: true
    });
    AdminComponent.prototype.goToAddoHome = function (event) {
        event.preventDefault();
        event.stopPropagation();
        // go to the base url
        window.location.href = "/";
        return false;
    };
    return AdminComponent;
}());
export { AdminComponent };



// WEBPACK FOOTER //
// ./src/app/admin/admin/admin.component.ts.pre-build-optimizer.js